import { api } from "@/lib/api";
import { toast } from "sonner";

// Launch Stripe Checkout for a given package_id.
// Requires the user to be signed in.
export async function launchCheckout(packageId, quantity = 1) {
  const token = localStorage.getItem("atlas_token");
  if (!token) {
    const redirect = encodeURIComponent(`/#pricing`);
    // Store intent so post-login we can auto-resume
    sessionStorage.setItem("atlas_pending_checkout", packageId);
    window.location.href = `/login?next=${redirect}`;
    return;
  }
  try {
    const { data } = await api.post("/billing/checkout", {
      package_id: packageId,
      origin_url: window.location.origin,
      quantity,
    });
    if (data.url) {
      window.location.href = data.url;
    } else {
      toast.error("No checkout URL returned");
    }
  } catch (err) {
    toast.error(err.response?.data?.detail || "Checkout failed to start");
  }
}
